// extracted by mini-css-extract-plugin
export var divider = "_v6-0";